import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';

const ReportArdilaPdf = async (data) => {

    console.log(data);

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        },
        CantoraOne: {
            bold: 'CantoraOne-Regular.ttf'
        }
    };

    const fecha = moment(data.fecha + " " + data.hora).format('lll');

    const contentPDF = [
        {
            text: 'EVALUACION MIOFUNCIONAL OROFACIAL', style: 'textHeader', margin: [0, 120, 0, 0]
        },
        {
            margin: [0, 10, 0, 10],
            columns: [
                {
                    ul: [
                        { text: 'Historia Clinica No. ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                        { text: data.names, bold: true, style: 'textStyle', listType: 'none' },
                        { text: 'No. Documento: ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                        { text: 'Edad: ' + data.age, style: 'textStyle', listType: 'none' },
                        { text: 'Remitido Por: ' + data.remitente, style: 'textStyle', listType: 'none' }
                    ]
                },
                {
                    ul: [
                        { text: ' ', style: 'textStyle', listType: 'none' },
                        { text: 'Dirección: ' + data.address, style: 'textStyle', listType: 'none' },
                        { text: 'Telefono: ' + data.telephone, style: 'textStyle', listType: 'none' },
                        { text: 'Ocupacion: ' + data.ocupation, style: 'textStyle', listType: 'none' },
                        { text: 'Entidad: ' + data.plan, style: 'textStyle', listType: 'none' },
                    ]
                },
            ],
            // optional space between columns
            columnGap: 10
        },
        {
            // auto-sized columns have their widths based on their content                                       
            margin: [0, 0, 0, 5],
            layout: {
                defaultBorder: false,
            },
            table: {
                headerRows: 1,
                widths: [90, '*', 200],
                heights: 20,
                body: [
                    [{ text: 'Tipo de Atención ', style: 'textStyle', border: [false, true, false, false] },
                    { text: 'Consulta', bold: true, style: 'textStyle', border: [false, true, false, false] },
                    { text: 'Fecha: ' + fecha, style: 'textStyle', border: [false, true, false, false] }],
                    [{ text: 'Firma Digital ', style: 'textStyle', border: [false, true, false, false] },
                    { text: 'SANDRA ARDILA', bold: true, style: 'textStyle', border: [false, true, false, false] },
                    { text: '', style: 'textStyle', border: [false, true, false, false] }],
                ]
            },
        }]

    if (data.motivo_consulta != undefined && data.motivo_consulta != null && data.motivo_consulta != "") {
        contentPDF.push({
            text: 'MOTIVO DE CONSULTA:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.motivo_consulta, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    if (data.antecedentes != undefined && data.antecedentes != null && data.antecedentes != "") {
        contentPDF.push({
            text: 'ANTECEDENTES PERSONALES Y FAMILIARES:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.antecedentes, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    if (data.observaciones != undefined && data.observaciones != null && data.observaciones != "") {
        contentPDF.push({
            text: 'OBSERVACIONES', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.observaciones, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    if (data.lengua != undefined && data.lengua != null && data.lengua != "") {
        contentPDF.push({
            text: 'LENGUA EN REPOSO/ PAYNE (PUNTOS DE CONTACTO DE LENGUA EN DEGLUCION):', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.lengua, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    if (data.observacionesDos != undefined && data.observacionesDos != null && data.observacionesDos != "") {
        contentPDF.push({
            text: 'OBSERVACIONES (ALIMENTACION):', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.observacionesDos, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    if (data.conclusiones != undefined && data.conclusiones != null && data.conclusiones != "") {
        contentPDF.push({
            text: 'CONCLUSIONES:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.conclusiones, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    if (data.recomendaciones != undefined && data.recomendaciones != null && data.recomendaciones != "") {
        contentPDF.push({
            text: 'RECOMENDACIONES:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
            {
                text: data.recomendaciones, style: 'textStyle', margin: [0, 0, 0, 10]
            });
    }

    contentPDF.push({
        text: 'MIOESCANOGRAFIA:', style: 'textStyle', bold: true, margin: [0, 10, 0, 2]
    },
        {
            // auto-sized columns have their widths based on their content                                       
            margin: [0, 0, 0, 10],
            layout: {
                defaultBorder: false,
            },
            table: {
                headerRows: 1,
                widths: ['*', '*', '*', '*', '*', '*', '*', '*'],
                body: [
                    [
                        { text: 'Labios ', bold: true, colSpan: 2, alignment: 'center', style: 'textStyle', border: [true, true, true, false] },
                        {},
                        { text: 'Lengua', bold: true, colSpan: 2, alignment: 'center', style: 'textStyle', border: [false, true, true, false] },
                        {},
                        { text: 'Maseteros', bold: true, colSpan: 2, alignment: 'center', style: 'textStyle', border: [false, true, true, false] },
                        {},
                        { text: 'Dinamometría', bold: true, colSpan: 2, alignment: 'center', style: 'textStyle', border: [false, true, true, false] },
                        {},
                    ],
                    [
                        { text: 'Normal ', style: 'textStyle', border: [true, false, false, false] },
                        { text: 'Paciente', style: 'textStyle', border: [false, false, true, false] },
                        { text: 'Normal ', style: 'textStyle', },
                        { text: 'Paciente', style: 'textStyle', border: [false, false, true, false] },
                        { text: 'Normal ', style: 'textStyle', },
                        { text: 'Paciente', style: 'textStyle', border: [false, false, true, false] },
                        { text: 'Normal ', style: 'textStyle', },
                        { text: 'Paciente', style: 'textStyle', border: [false, false, true, false] },
                    ],
                    [
                        { text: '0,5 ', style: 'textStyle', border: [true, true, false, false] },
                        { text: data.mioescanografia.labios, decoration: 'underline', style: 'textStyle', border: [false, true, true, false] },
                        { text: '0.8 ', style: 'textStyle', border: [false, true, false, false] },
                        { text: data.mioescanografia.lengua, decoration: 'underline', style: 'textStyle', border: [false, true, true, false] },
                        { text: '0,4 ', style: 'textStyle', border: [false, true, false, false] },
                        { text: data.mioescanografia.maseteros_der, decoration: 'underline', style: 'textStyle', border: [false, true, true, false] },
                        { text: '5 - 6 ', style: 'textStyle', border: [false, true, false, false] },
                        { text: data.mioescanografia.dinamometria, style: 'textStyle', decoration: 'underline', border: [false, true, true, false] },
                    ],
                    [
                        { text: '0.8', style: 'textStyle', border: [true, false, false, true] },
                        { text: '', style: 'textStyle', border: [false, false, true, true] },
                        { text: '1,2 ', style: 'textStyle', border: [false, false, false, true] },
                        { text: '', style: 'textStyle', border: [false, false, true, true] },
                        { text: '0,7', style: 'textStyle', border: [false, false, false, true] },
                        { text: data.mioescanografia.maseteros_izq, decoration: 'underline', style: 'textStyle', border: [false, false, true, true] },
                        { text: '', style: 'textStyle', border: [false, false, false, true] },
                        { text: '', style: 'textStyle', border: [false, false, true, true] }
                    ],
                ],
            },
        });

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: contentPDF,
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },

            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },
            textHeader: {
                fontSize: 11,
                font: 'OpenSans',
                bold: true,
                alignment: 'center',
            },
            foter: {
                alignment: 'center',
                fontSize: 8,
                font: 'OpenSans'
            },
        }
    }

    pdfMake.createPdf(documentDefinition).open();

}

export default ReportArdilaPdf